import { MenuItem } from '../../ui/dtos/menu-item';
import {
  faCog,
  faCreditCard,
  faFile,
  faListCheck,
  faPeopleGroup,
} from '@fortawesome/free-solid-svg-icons';
import { core } from '../../ui/side-nav/core-menu-items';
import { AdminUiSettings } from '../../common/dtos';

export function getAbcMenuItems(settings: AdminUiSettings): MenuItem[] {
  const menuItems = [core.projectsMenuItem];
  if (settings.entities.canManageEntities) {
    menuItems.push(core.entitiesMenuItem);
  } else {
    menuItems.push({
      label: 'People',
      url: '/main/abc/people',
      icon: faPeopleGroup,
    });
  }

  menuItems.push({
    label: 'Activities',
    url: '/main/abc/activities',
    icon: faFile,
  });

  if (settings.transactions.canManageTransactions) {
    menuItems.push({
      label: 'Transactions',
      url: '/main/accounts/transactions',
      icon: faCreditCard,
    });
  }

  // menuItems.push({
  //   label: 'Forms',
  //   url: '/main/abc/forms',
  //   icon: faListCheck,
  // });

  if (settings.users.canManageUsers) {
    menuItems.push(core.usersMenuItem);
  } else {
    // menuItems.push({
    //   label: 'My Account',
    //   url: '/main/abc/my-account',
    //   icon: faCog,
    // });
  }
  if (settings.coreCanvasModules.paymentsTabEnabled) {
    menuItems.push({
      label: 'Payments',
      url: '/main/abc/payments',
      icon: faCreditCard,
    });
  }

  menuItems.push(core.auditMenuItem);

  return menuItems;
}
